import { useEffect, useState } from "react";

import Checkbox from "shared/components/inputs/checkbox/Checkbox";
import FormInputWrapper from "shared/components/inputs/form/FormInputWrapper";
import SectionHead from "shared/components/layout/heads/SectionHead";
import { StyledHeader } from "shared/components/data-display/drawers/MasterDrawer.styles";
import VStack from "shared/components/layout/stack/VStack";
import { useNavigate } from "react-router-dom";
import {
    StyledMessageWrapper,
    StyledAction,
    StyledRedirectToFooter,
    Wrapper,
} from "./RedirectTo.styles";

const RedirectTo = () => {
    const [checked, setChecked] = useState(false);
    const [sessionStatus] = useState(localStorage.getItem("VPNAlert"));
    const queryParameters = new URLSearchParams(globalThis.location.search)
    const redirectTo = queryParameters.get("url");
    const navigate = useNavigate();

    const handleCancel = () => {
        if (globalThis.history.length < 2) {
            globalThis.close();
        } else {
            navigate(-1);
        }
    };

    useEffect(() => {
        if (sessionStatus && sessionStatus === "true") {
            globalThis.location.replace(redirectTo);
        }
    }, [sessionStatus, redirectTo]);

    const rememberCheck = () => {
        localStorage.setItem("VPNAlert", !checked);
        setChecked(!checked);
    }

    return (
        (!sessionStatus || sessionStatus === "false") && (
            <Wrapper>
                <>
                    <Wrapper>
                        <StyledHeader>
                            <SectionHead title="Are you connected to the VPN?" />
                        </StyledHeader>
                        <StyledMessageWrapper>
                            <VStack spacing="Two" style={{ paddingTop: "32px" }}>
                                <div
                                    color="Gray_1"
                                >
                                    {`You are going to a page that requires VPN connection.\n
                                 Make sure you are connected before continuing.`}
                                </div>
                                <FormInputWrapper
                                    feedbackType={checked ? "Success" : "None"}
                                    feedbackMessage={
                                        checked &&
                                        "You won't be asked again during this session."
                                    }
                                >
                                    <Checkbox
                                        label="Don't ask again."
                                        onChange={() => rememberCheck()}
                                    />
                                </FormInputWrapper>
                            </VStack>
                        </StyledMessageWrapper>
                        <StyledAction
                            primaryAction={{
                                type: "button",
                                label: "Continue",
                                leadingIcon: "arrow-right",
                                href: redirectTo,
                                rel: "noreferrer",
                                target: "_self",
                            }}
                            secondaryAction={{
                                type: "button",
                                label: "Cancel",
                                onClick: handleCancel,
                            }}
                        />
                    </Wrapper>
                    <StyledRedirectToFooter />
                </>
            </Wrapper>
        )
    );
};

export default RedirectTo;
